import WebImage1 from '../images/Screenshot from 2023-05-24 21-45-23.png';
import WebImage2 from '../images/web-project-2.jpg';
import MobileImage1 from '../images/Screenshot from 2023-05-24 21-41-54.png';
import MobileImage2 from '../images/Screenshot from 2023-05-24 21-10-11.png';
import UIImage1 from '../images/Screenshot from 2023-05-24 20-21-50.png';
import UIImage2 from '../images/Screenshot from 2023-05-24 21-24-18.png';

import SwiftRidesImg from '../images/swiftrides.png';
import MacLabImg from '../images/virtualbox.png';
import DevsKenyaImg from '../images/devskenya.png';
import ScoreXImg from '../images/scorex.png';
import SkyReelsImg from '../images/skyreels.png';
import ConstructionPlatformImg from '../images/construction.png';
import AdminDashboardImg from '../images/admin.png';
import CommunityForumImg from '../images/community.png';
import EmailAutomationImg from '../images/email.png';
import FileUploadApprovalImg from '../images/upload.png';
import AnnouncementSystemImg from '../images/announcement.png';
import Car3DConfiguratorImg from '../images/3d.png';
import FixAfricaImg from '../images/fixafrica.png';

const baseProjects = [
  {
    id: 1,
    title: 'Car Enthusiast Kenya',
    category: 'Web Application',
    img: WebImage2,
    liveLink: 'https://car-enthusiast-kenya.vercel.app/',
  },
  {
    id: 11,
    title: 'Developers Kenya',
    category: 'Dev Community Platform',
    img: DevsKenyaImg,
    liveLink: 'https://developerskenya.co.ke',
  },
  {
    id: 7,
    title: 'Swift Rides Kenya',
    category: 'Car Rental Platform',
    img: SwiftRidesImg,
    liveLink: 'https://swiftrideskenya.com',
  },
  {
    id: 9,
    title: 'ScoreX',
    category: 'Sports / Analytics',
    img: ScoreXImg,
    liveLink: 'https://scorex.co.ke',
  },
  {
    id: 12,
    title: 'SkyReels',
    category: 'Local AI Video Generator',
    img: SkyReelsImg,
    liveLink: '#',
  },
  {
    id: 8,
    title: 'Fix Africa',
    category: 'Service Platform',
    img: FixAfricaImg,
    liveLink: 'https://fixafrica.co.ke',
  },
  {
    id: 2,
    title: 'Realtor Clone App',
    category: 'Design Web Application',
    img: MobileImage2,
    liveLink: 'https://realtor-app-clone.vercel.app/',
  },
  {
    id: 3,
    title: 'Safari Boys',
    category: 'Web Application',
    img: UIImage1,
    liveLink: 'https://safari.fixafrica.co.ke/',
  },
  {
    id: 4,
    title: 'Moringa School Alumni',
    category: 'Web Application',
    img: UIImage2,
    liveLink: 'https://moringa-alumni.vercel.app/',
  },
  {
    id: 5,
    title: 'Car Enthusiast Visualizer',
    category: 'Android/IOS Application',
    img: MobileImage1,
    liveLink: 'https://car-enthusiasts-visualizer.netlify.app/',
  },
  {
    id: 6,
    title: 'Fix Moti`s',
    category: 'Website',
    img: WebImage1,
    liveLink: 'https://fix-motis-gallery.vercel.app/',
  },
  {
    id: 13,
    title: 'VirtualBox Lab',
    category: 'Infrastructure / MacOS VM',
    img: MacLabImg,
    liveLink: '#',
  },
  {
    id: 14,
    title: '3D Car Configurator',
    category: 'Interactive 3D Web',
    img: Car3DConfiguratorImg,
    liveLink: '#',
  },
  {
    id: 15,
    title: 'Construction Platform',
    category: 'Consultancy System',
    img: ConstructionPlatformImg,
    liveLink: '#',
  },
  {
    id: 16,
    title: 'Admin Dashboard Framework',
    category: 'Internal Tools',
    img: AdminDashboardImg,
    liveLink: '#',
  },
  {
    id: 17,
    title: 'Community Forum System',
    category: 'Social Software',
    img: CommunityForumImg,
    liveLink: '#',
  },
  {
    id: 18,
    title: 'Email Automation System',
    category: 'Marketing Automation',
    img: EmailAutomationImg,
    liveLink: '#',
  },
  {
    id: 19,
    title: 'File Upload & Approval',
    category: 'Workflow System',
    img: FileUploadApprovalImg,
    liveLink: '#',
  },
  {
    id: 20,
    title: 'Announcement System',
    category: 'Notification Service',
    img: AnnouncementSystemImg,
    liveLink: '#',
  },
];

const detailsById = {
  1: {
    summary: 'A car visualizer built for a prospective small auto-business looking to move their platform and increase their presence on the internet.',
    outcome: 'Increased online presence and engagement through interactive 3D visualizations.',
    stack: ['React', 'HTML', 'CSS', 'JavaScript'],
    entails: [
      'Interactive car visualizer tool',
      'Small business migration to the web',
      'Performance tuning for mobile-first consumption',
    ],
  },
  2: {
    summary: 'A production-style property search experience with refined UI states and listing interactions.',
    outcome: 'Improved user journey from browse to contact with conversion-aware UI decisions.',
    stack: ['React', 'Firebase', 'Tailwind', 'Auth'],
    entails: [
      'Property card and map-aware exploration UX',
      'Authentication and listing management flows',
      'Responsive layout built for low-end devices',
    ],
  },
  3: {
    summary: 'A modern service web app for lifestyle and mobility-focused customer journeys.',
    outcome: 'Delivered a cleaner funnel from landing page through engagement action.',
    stack: ['React', 'REST APIs', 'Framer Motion', 'Vercel'],
    entails: [
      'Animated landing sections with clear CTA hierarchy',
      'Reusable service modules and content sections',
      'Deployment-ready architecture with simple scaling path',
    ],
  },
  4: {
    summary: 'A community platform for alumni networking, updates, and opportunities.',
    outcome: 'Created a reusable base for education communities and alumni-driven engagement.',
    stack: ['React', 'Node.js', 'MongoDB', 'Email'],
    entails: [
      'Member-oriented content and announcement workflows',
      'Forms and profile-driven community interactions',
      'Structured information architecture for long-term growth',
    ],
  },
  5: {
    summary: 'An immersive visualizer concept that blends automotive design with interactive product demos.',
    outcome: 'Proved high-engagement product storytelling through visual-first interface patterns.',
    stack: ['JavaScript', '3D UI', 'Responsive Design', 'Animation'],
    entails: [
      'Interactive visual flow for configuration previews',
      'Motion transitions and touch-first navigation',
      'Branded layout system for campaign reuse',
    ],
  },
  6: {
    summary: 'A gallery of cards displaying information about cars, detailing the make, model, engine, horsepower, and pictures. Users can also add their own custom car images.',
    outcome: 'Created a highly engaging interactive gallery with user-generated content capabilities.',
    stack: ['React', 'Ruby on Rails', 'SQLite 3', 'db.json'],
    entails: [
      'Image upload and gallery rendering',
      'Detailed car specifications display',
      'Interactive React component structure',
    ],
  },
  7: {
    summary: 'A booking and inventory platform for rental operations, built for trust and speed.',
    outcome: 'Enabled faster booking workflows and clearer vehicle discovery.',
    stack: ['React', 'Booking Logic', 'Payments Ready', 'Cloud'],
    entails: [
      'Availability-driven booking interfaces',
      'Vehicle detail pages with pricing clarity',
      'Scalable service architecture for new locations',
    ],
  },
  8: {
    summary: 'A service marketplace architecture connecting users to trusted providers efficiently.',
    outcome: 'Improved lead quality by standardizing request and matching workflows.',
    stack: ['React', 'Node.js', 'Matching Logic', 'Workflow'],
    entails: [
      'Service category intelligence and request capture',
      'Provider-facing onboarding and visibility controls',
      'Conversion-aware UI for faster task posting',
    ],
  },
  9: {
    summary: 'A sports analytics product built to transform raw match data into decision-ready insights.',
    outcome: 'Created a reliable foundation for visual analytics and live score intelligence.',
    stack: ['Analytics', 'Data Visualization', 'APIs', 'Dashboard'],
    entails: [
      'Insight cards and trend-driven chart sections',
      'Live data ingestion and sanity-check flows',
      'Performance-first rendering for stats-heavy pages',
    ],
  },
  11: {
    summary: 'A professional network product that supports local developers with community and visibility tools.',
    outcome: 'Increased discoverability of local talent through profile and content modules.',
    stack: ['React', 'Community', 'Profile Systems', 'Moderation'],
    entails: [
      'Member profile architecture and discoverability',
      'Community feed with contribution pathways',
      'Moderation and growth-ready admin workflows',
    ],
  },
  12: {
    summary: 'An AI-assisted video generation concept focused on lightweight local creation workflows.',
    outcome: 'Validated product direction for creators who need speed over complexity.',
    stack: ['AI', 'Prompt UX', 'Media Pipeline', 'Frontend'],
    entails: [
      'Prompt-to-preview generation flow design',
      'Asset management and version awareness',
      'Creator-first interface with minimal friction',
    ],
  },
  13: {
    summary: 'A virtualized infrastructure lab to test deployment reliability and security scenarios.',
    outcome: 'Enabled safe experimentation for systems architecture and troubleshooting drills.',
    stack: ['VirtualBox', 'Linux', 'Networking', 'DevOps'],
    entails: [
      'Isolated VM environment and network segmentation',
      'Repeatable setup scripts and baseline images',
      'Sandboxed testing for infrastructure changes',
    ],
  },
  14: {
    summary: 'An interactive 3D product experience built for premium showroom-style engagement.',
    outcome: 'Improved session depth through visual interaction and instant customization feedback.',
    stack: ['Three.js', 'WebGL', 'React', 'UI Motion'],
    entails: [
      'Real-time material and color customization',
      'High-frame-rate interactive scene controls',
      'Progressive optimization for mobile GPUs',
    ],
  },
  15: {
    summary: 'A consultancy operations system that organizes projects, clients, and delivery checkpoints.',
    outcome: 'Reduced manual coordination overhead with structured workflow tooling.',
    stack: ['Workflow', 'Admin UX', 'Forms', 'Data Layer'],
    entails: [
      'Multi-step intake and project qualification flow',
      'Project milestone visibility and task routing',
      'Operational dashboards for team coordination',
    ],
  },
  16: {
    summary: 'A reusable dashboard shell for internal teams managing data-heavy operational tasks.',
    outcome: 'Cut implementation time for new internal tools with reusable modules.',
    stack: ['Dashboard', 'Component System', 'Tables', 'Auth'],
    entails: [
      'Role-aware navigation and permission scaffolding',
      'Metrics cards, data tables, and management views',
      'Theme-ready component architecture',
    ],
  },
  17: {
    summary: 'A discussion platform blueprint designed for meaningful engagement and moderation control.',
    outcome: 'Balanced community growth with safer participation mechanics.',
    stack: ['Forum', 'Moderation', 'Engagement', 'Search'],
    entails: [
      'Thread, reply, and reaction interaction model',
      'Content moderation and reporting surfaces',
      'Community health metrics and discovery UX',
    ],
  },
  18: {
    summary: 'An automation engine for campaigns, transactional messaging, and lifecycle communication.',
    outcome: 'Reduced manual campaign operations through trigger-based messaging.',
    stack: ['Email', 'Automation', 'Triggers', 'Templates'],
    entails: [
      'Template management and dynamic personalization',
      'Queue-driven send architecture',
      'Campaign analytics and delivery monitoring',
    ],
  },
  19: {
    summary: 'A structured approval workflow for document intake, validation, and release.',
    outcome: 'Improved compliance and processing speed with traceable approvals.',
    stack: ['Workflow', 'File Management', 'Approvals', 'Audit Trail'],
    entails: [
      'Upload gates with status-aware validation',
      'Reviewer assignment and approval stages',
      'Audit logs for operational accountability',
    ],
  },
  20: {
    summary: 'A high-reliability notice system for organization-wide communication.',
    outcome: 'Standardized urgent and routine communication in one controlled channel.',
    stack: ['Notifications', 'Scheduling', 'Roles', 'Broadcast'],
    entails: [
      'Audience targeting and scheduled publishing',
      'Priority tiers for urgent announcements',
      'Read-state analytics and reporting',
    ],
  },
};

const genericProjectDetails = {
  summary: 'A product-focused build with scalable architecture, interaction-first UX, and reliable delivery patterns.',
  outcome: 'Improved delivery velocity and user confidence through practical engineering decisions.',
  stack: ['React', 'Node.js', 'Design System'],
  entails: [
    'User-focused interface architecture',
    'Reusable component patterns',
    'Deployment-ready project structure',
  ],
};

export const projectsData = baseProjects.map((project) => ({
  ...project,
  ...genericProjectDetails,
  ...(detailsById[project.id] || {}),
}));
